import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import { ModuleSearchField, ResponsiveDialog, useSettings, useUserData, Utils } from 'app/main/components';

interface CommercialCampaignsRowsAddSingleDialogProps {
	openDialog: boolean;
	switchOpenDialog: () => void;
	table: string;
	cmcpUid: string;
	updateRefresh: () => void;
}

export default function CommercialCampaignsRowsAddSingleDialog(props: CommercialCampaignsRowsAddSingleDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.table);
	const userData = useUserData();

	const [uid, setUid] = React.useState(null);

	const addRow = () => {
		Utils.executeStored({
			action: 'st_commercialcampaigns_rows_add_multiple',
			dispatch,
			data: {
				cmrw_cmcp_uid: props.cmcpUid,
				cmrw_user_created_uid: userData.user_uid,
				cmrw_table: settings.modu_title,
				filters: [{ filt_field: `${settings.modu_short}_uid`, filt_clause: 'equals', filt_value: uid }]
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				props.switchOpenDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog
			open={props.openDialog}
			onClose={props.switchOpenDialog}
			maxWidth="xs"
			title={t('COMMERCIALCAMPAIGNS_SECTION_ADD_TITLE')}
			content={
				<ModuleSearchField
					name={`${settings.modu_short}_uid`}
					label={t(`MODULE_${settings.modu_title}_NAME_SINGULAR`)}
					module={settings.modu_title}
					uid={uid}
					isEdit
					sendChange={(_name, value) => setUid(value)}
				/>
			}
			actions={
				<>
					<Button onClick={props.switchOpenDialog}>{t('DIALOG_ACTION_BACK')}</Button>
					<Button disabled={!uid} onClick={addRow}>
						{t('DIALOG_ACTION_ADD')}
					</Button>
				</>
			}
		/>
	);
}
